import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faChartPie,
  faUserTie,
  faUserSecret,
  faGear,
  faJetFighter,
  faDesktop,
  faEarthAmericas,
  faCommentDots,
  faNewspaper,
  faSignOutAlt,
  faRocket,
  faEye,
  faVideo
} from "@fortawesome/free-solid-svg-icons";
import { faToolbox } from "@fortawesome/free-solid-svg-icons";
import "../styles/sidebar.css";

function Sidebar() {
  const [collapsed, setCollapsed] = useState(false);
  const [animateNotam, setAnimateNotam] = useState(true);
  const [manualReset, setManualReset] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);
 

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const stopAnimation = () => {
      setAnimateNotam(false);
      setManualReset(false);
    };

    const timer = setTimeout(stopAnimation, 3 * 60 * 1000);
    return () => clearTimeout(timer);
  }, []);

  const handleMouseEnterNotam = () => {
    setAnimateNotam(true);
    setManualReset(true);

    setTimeout(() => setAnimateNotam(false), 3 * 60 * 1000);
  };

  const toggleSettings = () => {
    setSettingsOpen((prev) => !prev);
  };

  const handleLogout = () => {
    // Clear all items in localStorage
    localStorage.clear();

    // Clear all items in sessionStorage
    sessionStorage.clear(); // This will clear sessionStorage as well

    // Navigate to the login page
    navigate("/login");
  };

 

  return (
    <div className={`sidebar ${collapsed ? "collapsed" : ""}`}>
      <div className="sidebar-header">
        <img src={`${process.env.PUBLIC_URL}/icons/logo.png`} alt="Logo" />
        <button className="toggle-btn" onClick={() => setCollapsed(!collapsed)}>
          <img
            src={`${process.env.PUBLIC_URL}/icons/toggle.png`}
            alt="Toggle"
          />
        </button>
      </div>

      <div className="sidebar-menu">Social Insight</div>
      <hr />

      <div className="sidebar-middle">
        <div className="menu-items-container">
          <div
            className={`menu-item ${
              location.pathname === "/deck" ? "selected" : ""
            }`}
          >
            <Link to="/deck">
              <FontAwesomeIcon icon={faDesktop} />
              <span>Monitoring Deck</span>
            </Link>
          </div>
          <div
            className={`menu-item ${
              location.pathname === "/location-search" ? "selected" : ""
            }`}
          >
            <Link to="/location-search">
              <FontAwesomeIcon icon={faEarthAmericas} />
              <span>Location Search</span>
            </Link>
          </div>
{/* 
          <div
            className={`menu-item ${
              location.pathname === "/comment-monitoring" ? "selected" : ""
            }`}
          >
            <Link to="/comment-monitoring">
              <FontAwesomeIcon icon={faCommentDots} />
              <span>Comments Monitoring</span>
            </Link>
          </div> */}
         
          <div
            className={`menu-item notam ${
              location.pathname === "/notam" ? "selected" : ""
            }`}
            onMouseEnter={handleMouseEnterNotam}
            onMouseLeave={() => setManualReset(false)}
         
          >
            <Link to="/notam">
              <FontAwesomeIcon icon={faJetFighter} />
              <span className={animateNotam || manualReset ? "animate" : ""}>
                N.O.T.A.M
        
              </span>
            </Link>
          </div>

          <div
            className={`menu-item ${
              location.pathname === "/profiling" ? "selected" : ""
            }`}
          >
            <Link to="/profiling">
              <FontAwesomeIcon icon={faUserTie} />
              <span>Profiling</span>
            </Link>
          </div>

          <div
            className={`menu-item ${
              location.pathname === "/originator" ? "selected" : ""
            }`}
          >
            <Link to="/originator">
              <FontAwesomeIcon icon={faUserSecret} />
              <span>Originator</span>
            </Link>
          </div>

   
          <div
            className={`menu-item ${
              location.pathname === "/graph" ? "selected" : ""
            }`}
          >
            <Link to="/graph">
              <FontAwesomeIcon icon={faChartPie} />
              <span>Relation Mapping</span>
            </Link>
          </div>

          <div
            className={`menu-item ${
              location.pathname === "/analytics" ? "selected" : ""
            }`}
          >
            <Link to="/analytics">
              <FontAwesomeIcon icon={faChartPie} />
              <span>Analytics</span>
            </Link>
          </div>

          <div
  className={`menu-item ${location.pathname === "/darkhawk" ? "selected" : ""}`}
>
  <a
    href="http://108.181.202.203:9002"  // Replace with the actual IP and port
    target="_blank"
    rel="noopener noreferrer"
  >
    <FontAwesomeIcon icon={faRocket} />
    <span>Dark Hawk</span>
  </a>
</div>
<div
  className={`menu-item ${location.pathname === "/teleye" ? "selected" : ""}`}
>
  <a
    href="http://108.181.202.203:9003"  // Replace with the actual IP and port for Teleye
    target="_blank"
    rel="noopener noreferrer"
  >
    <FontAwesomeIcon icon={faEye} />
    <span>Teleye</span>
  </a>
</div>

<div
  className={`menu-item ${location.pathname === "/ytspot" ? "selected" : ""}`}
>
  <a
    href="http://108.181.202.203:9000"  // Replace with the actual IP and port for YTSpot
    target="_blank"
    rel="noopener noreferrer"
  >
    <FontAwesomeIcon icon={faVideo} />
    <span>YTSpot</span>
  </a>
</div>

          <div className="menu-item" onClick={toggleSettings}>
            <FontAwesomeIcon icon={faGear} />
            <span>Settings</span>
          </div>

          {settingsOpen && (
            <div className="sub-menu">
              <div
                className={`menu-item ${
                  location.pathname === "/adminpanel" ? "selected" : ""
                }`}
              >
                <Link to="/adminpanel">
                  <FontAwesomeIcon icon={faToolbox} />
                  <span>Admin Panel</span>
                </Link>
              </div>
              {/* <div
                className={`menu-item ${
                  location.pathname === "/news-bulletin" ? "selected" : ""
                }`}
              >
                <Link to="/news-bulletin">
                  <FontAwesomeIcon icon={faNewspaper} />
                  <span>News Bulletin</span>
                </Link>
              </div> */}
              <div
                className={`menu-item ${
                  location.pathname === "/superadmin" ? "selected" : ""
                }`}
              >
                <Link to="/superadmin">
                  <FontAwesomeIcon icon={faNewspaper} />
                  <span>Super Admin</span>
                </Link>
              </div>
            </div>
          )}

          <div className="menu-item logout">
            <button onClick={handleLogout} className="logout-button">
              <FontAwesomeIcon icon={faSignOutAlt} />
              <span>Logout</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
